import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HoldItemList } from "../../shared/models/holdItemList.model";
import moment from "moment";
import { HtlService } from "../../htl/htl.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from "../../shared/shared.service";
import { LocalStorageService } from "../../shared/local-storage.service";
import { HHMM } from "@rrsolutionsit/atl-utils";

@Component({
    selector: "app-update-hold-item-list-dialog",
    templateUrl: "./update-hold-item-list-dialog.component.html",
    styleUrls: ["./update-hold-item-list-dialog.component.scss"],
    standalone: false,
})
export class UpdateHoldItemListDialogComponent implements OnInit {
    public hilFormGroup: FormGroup;

    private _userSession;

    public showFlightNumber = false;

    public helicopterData;
    public totalHours: string;
    public totalCycles: number;

    constructor(
        public dialogRef: MatDialogRef<UpdateHoldItemListDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            helicopterId: number;
            showFlightNumber: boolean;
            helicopterData: any;
        },
        private _formBuilder: FormBuilder,
        private _htlService: HtlService,
        private _snackBar: MatSnackBar,
        private _translate: TranslateService,
        private _sharedService: SharedService,
        private _localStorageService: LocalStorageService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
        this.hilFormGroup = this._formBuilder.group({
            id: [""],
            openingDate: ["", Validators.required],
            description: ["", Validators.required],
            ataChap: [""],
            melRef: [""],
            expExpDate: ["", Validators.required],
            expExpFlightHours: [""],
            expExpFlightNumber: [""],
            expExpCycles: [""],
            helicopterId: [this._data.helicopterId],
        });

        if (this._data.showFlightNumber) {
            this.showFlightNumber = this._data.showFlightNumber;
        }

        if (this._data.helicopterData) {
            this.helicopterData = this._data.helicopterData;
            this.totalHours = HHMM.sumTimes(this.helicopterData?.totalHours, this.helicopterData?.flightSUM).value;
            this.totalCycles = this.helicopterData?.totalCycles + this.helicopterData?.currentCycles;
        }
    }

    ngOnInit(): void {}

    onFormSubmit() {
        if (this.hilFormGroup.valid) {
            const hilObject = this.hilFormGroup.value as HoldItemList;
            hilObject.openingDate = moment(hilObject.openingDate).format("YYYY-MM-DD");
            if (hilObject.expExpDate) {
                hilObject.expExpDate = moment(hilObject.expExpDate).format("YYYY-MM-DD");
            }
            this._htlService.insertNewHoldItemList(hilObject, this._userSession.username).subscribe((result) => {
                this.dialogRef.close(result);
                this._snackBar.open(this._translate.instant("GENERAL.savedSuccessMsg"), this._translate.instant("GENERAL.close"), {
                    duration: 3000,
                });
            });
        } else {
            const errors = this._sharedService.checkIfFormGroupHasError(this.hilFormGroup);
            errors.map((error) => {
                this.hilFormGroup.get(error.key).setErrors({ required: true });
                this.hilFormGroup.get(error.key).markAsTouched();
            });
        }
    }
}
